import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
	selector: 'app-panic-mode-modal',
	templateUrl: './panic-mode-modal.component.html',
	styleUrls: ['./panic-mode-modal.component.scss'],
	standalone: false,
})
export class PanicModeModalComponent {
	private modalCtrl = inject(ModalController);

	static async show(modalCtrl: ModalController) {
		const modal = await modalCtrl.create({
			component: PanicModeModalComponent,
			cssClass: 'auto-height item-modal reduced-width-modal',
			showBackdrop: true,
			backdropDismiss: true,
		});
		return await modal.present();
	}

	closeReceiptError() {
		this.modalCtrl.dismiss();
	}
}
